<div class="row">
  <div class="col-md-3">
    <div class="ddc-table-div-container mat-elevation-z4">
      <table mat-table matSort [dataSource]="adherentsDisponiblesTableDataSource">
        <ng-container matColumnDef="prenomNom">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.adherent.prenomNom"></span>
          </th>
          <td mat-cell *matCellDef="let adherent"> {{adherent.prenom}}  {{adherent.nom}} </td>
        </ng-container>

        <ng-container matColumnDef="ajouter">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let structure; let i = index;">
            <button
              mat-flat-button class="ddc-button-primary"
              (click)="ajouterAdherentDisponibleSelectionne(i)"
              [disabled]="_isSaving">
              <i class="material-icons">add_circle</i>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="adherentsDisponiblesTableDisplayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: adherentsDisponiblesTableDisplayedColumns;"></tr>
      </table>
    </div>
  </div>

  <div class="col-md-9">
    <div class="ddc-table-div-container mat-elevation-z4">
      <table mat-table [dataSource]="encadrantsNautiquesTableDataSource">
        <ng-container matColumnDef="roleNavigationMarin">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.role"></span>
          </th>
          <td mat-cell *matCellDef="let control">
            <ng-container
              *ngIf="getDdcModuleMarinEncadrantNautiqueIcon(control.get('roleNavigationMarin')?.value) && _typeDossier == TypeDossierEnum.CAMP; let roleNavigationMarin">
              <img [src]="roleNavigationMarin.icon" width="24px" height="24px" />
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="prenomNom">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.prenomNom"></span>
          </th>
          <td mat-cell
              *matCellDef="let control"> {{control.get('adherent').value.prenom}} {{control.get('adherent').value.nom}}</td>
        </ng-container>

        <ng-container matColumnDef="diplome">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.diplome"></span>
          </th>
          <td mat-cell
              *matCellDef="let control">{{getAdherentDiplomesMarinLabel(control.get('adherent').value.numero, adherentsInformations)}}</td>
        </ng-container>

        <ng-container matColumnDef="supprimer">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let campStructure; let i = index;">
            <button
              mat-flat-button color="warn"
              (click)="supprimerDdcModuleMarinEncadrantNautiqueSelectionne(i)"
              [disabled]="_isSaving">
              <i class="material-icons">remove_circle</i>
            </button>
          </td>
        </ng-container>

        <ng-container *ngIf="_typeDossier == TypeDossierEnum.CAMP; else TypeDossierProjetAnnee">
          <tr mat-header-row *matHeaderRowDef="ddcEncadrantsNautiquesTableDisplayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: ddcEncadrantsNautiquesTableDisplayedColumns;"
              (click)="selectionnerDdcModuleMarinEncadrantNautique(row)"
              [class.table-active]="row === encadrantNautiqueSelectionneFormGroup"
              [class.table-danger]="row.invalid">
          </tr>
        </ng-container>
        <ng-template #TypeDossierProjetAnnee>
          <tr mat-header-row *matHeaderRowDef="ddcEncadrantsNautiquesTableDisplayedColumnsForProjetAnnee; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: ddcEncadrantsNautiquesTableDisplayedColumnsForProjetAnnee;"
              (click)="selectionnerDdcModuleMarinEncadrantNautique(row)"
              [class.table-active]="row === encadrantNautiqueSelectionneFormGroup"
              [class.table-danger]="row.invalid">
          </tr>
        </ng-template>
      </table>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-5">
    <div class="row">
      <mat-form-field floatLabel="always" class="col">
        <mat-label ddcLabel labelKey="appli.camp.onglet.jeunes.ajouterAdherentParCode" class="link"></mat-label>
        <input matInput type="number" [formControl]="codeAdherentEntryForm.get('participant')">
        <mat-error *ngIf="codeAdherentEntryForm.get('participant').errors">
          {{codeAdherentEntryForm.get('participant').errors.errorMessage}}
        </mat-error>
        <mat-hint>Entrez 9 chiffres</mat-hint>
      </mat-form-field>

      <div class="col-auto ddc-textfield-btn-div">
        <button mat-raised-button [disabled]="disableCodeSubmitButton(codeAdherentEntryForm.get('participant'))"
                (click)="addParticipantByCodeEntry()" class="ddc-button-primary"><i class="material-icons">add_circle</i>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="encadrantNautiqueSelectionneFormGroup">
  <mat-card class="ddc-subcard-with-title">
    <mat-card-title>
      Maitrise : {{encadrantNautiqueSelectionneFormGroup.get('adherent')?.value.prenom}}
      {{encadrantNautiqueSelectionneFormGroup.get('adherent')?.value.nom}}
    </mat-card-title>
    <mat-card-content>
      <div ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.carte.encadrantNautique.description" class="ddc-appli-description"></div>
      <div class="row">
        <div class="col-md-3">
          <div class="ddc-read-only-data-container">
            <span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.numeroAdherent"></span>&nbsp;
            <span class="ddc-value">{{numeroAdherentSelectionne}}</span>
          </div>
        </div>
      </div>
      <hr/>
      <div *ngIf="_typeDossier == TypeDossierEnum.CAMP" class="row">
        <mat-form-field floatLabel="always" class="col-md-4">
          <mat-label ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.role"></mat-label>
          <mat-select [formControl]="encadrantNautiqueSelectionneFormGroup.get('roleNavigationMarin')" required>
            <mat-option *ngFor="let roleActiviteNavigation of ROLES_ACTIVITE_NAVIGATION"
                        [value]="roleActiviteNavigation.value">
              {{roleActiviteNavigation.text}}
            </mat-option>
          </mat-select>
          <mat-error ddcMatError
                     [control]="encadrantNautiqueSelectionneFormGroup.get('roleNavigationMarin')"></mat-error>
        </mat-form-field>
      </div>

      <ng-container *ngIf="adherentsInformations[numeroAdherentSelectionne]">
        <div class="row">
          <div class="col-md-12 ddc-adherent-info-title">
            <b><span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.diplome.title"></span></b>
          </div>
        </div>
        <ng-container
          *ngIf="adherentsInformations[numeroAdherentSelectionne].adherentDiplomes && adherentsInformations[numeroAdherentSelectionne].adherentDiplomes.length > 0; else noAdherentDiplomesBlock">
          <div class="row">
            <div class="col-md-12">
              <table class="read-only-mat-table" mat-table
                     [dataSource]="getAdherentDiplomesMarin(numeroAdherentSelectionne, adherentsInformations)">
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.diplome.type"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentDiplome"> {{adherentDiplome.type}} </td>
                </ng-container>

                <ng-container matColumnDef="dateObtention">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel
                          labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.diplome.dateObtenation"></span>
                  </th>
                  <td mat-cell
                      *matCellDef="let adherentDiplome"> {{convertToHumanDate(adherentDiplome.dateObtention)}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="adherentDiplomesTableDisplayedComumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: adherentDiplomesTableDisplayedComumns;"></tr>
              </table>
            </div>
          </div>
        </ng-container>
        <ng-template #noAdherentDiplomesBlock>
          <div class="row">
            <div class="col-md-12">
              <span ddcLabel labelKey="appli.shared.encadrantNautiqueSelector.encadrantNautique.diplome.noDiplomes"></span>
              <hr/>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
